import * as React from 'react';
import { useState } from 'react';
import { default as NextImage, ImageProps } from 'next/image';
import styles from './gallery.module.scss';
import { RingsSpinner } from '@weddingspot/ws-core-components';

interface OwnProps {
    spinner?: boolean;
    photoCredit?: string;
}
const WrappedImage = (props: ImageProps & OwnProps) => {
    const [imageIsLoaded, setImageIsLoaded] = useState(false);

    return (
        <div className={styles.wrappedImage}>
            <div className={styles.photoCredit}>{props.photoCredit}</div>
            {props.spinner && !imageIsLoaded && <RingsSpinner animate={true} />}
            {props.src && (
                <NextImage
                    {...props}
                    onLoad={(e) => {
                        // @ts-ignore
                        // next renders 1x1 gif as placeholder
                        e.target.src.indexOf('data:image/gif;base64') < 0 && setImageIsLoaded(true);
                    }}
                />
            )}
        </div>
    );
};

export default WrappedImage;
